export const getGroupPeriodExcelData = (excelData) => {
  return [
    [],
    ["", "Before submission export entire workbook in PDF format"],
    [],
    [
      "",
      "This template is suitable for up to 300 companies. It can be used where some company accounting periods do not end on the same date as the worldwide group period of account",
    ],
    [],
    [],
    ["", "Interest Restriction Return Page 1 (Full return)"],
    [],
    [
      "",
      "Identifies worldwide group, return period and type of interest restriction return (Full or abbreviated return)",
    ],
    [],
    ["", "Period of account covered by interest restriction return"],
    excelData.start_period_account,
    excelData.end_period_account,
    [],
    excelData.rep_comp_name,
    excelData.rep_comp_UTR,
    [],
    excelData.ultimate_parent,
    excelData.ult_parent_line2,
    excelData.ult_parent_line3,
    excelData.ult_parent_line4,
    excelData.ult_parent_optional,
    [],
    ["", "Type of return", "Enter Yes or No"],
    excelData.abbreviated_election,
    excelData.revised_return,
    [
      "",
      "For a revised return, specify differences in white space box provided below ",
    ],
    [],
    [
      "",
      "Whether subject to interest restriction or reactivation (if so, full return required)",
      "Enter Yes or No",
    ],
    excelData.subject_to_restrictions,
    excelData.subject_to_reactivations,
    [],
    ["", "Ways in which revised return differs from the return it supersedes"],
    [
      "",
      "A brief narrative is sufficient, e.g allocation of restictions changed or full return replaces abbreviated return",
    ],
    excelData.nature_of_revision,
    [],
    ["", "Free space to include notes to the return"],
    excelData.details_of_estimation,
    [],
    [
      "",
      "Information required only in the unusual circumstances where there are deemed parents (s477 or 478 TIOPA 2010)",
    ],
    ["", "", "Name", "UTR, if any, 10 digits"],
    ["", "Deemed parent (1)", ""],
    ["", "Deemed parent (2)", ""],
    ["", "Deemed parent (3)", ""],
    [],
    ["", "Key"],
    ["", "Descriptive Field", "Note"],
    [],
    [],
    excelData.return_details,
  ];
};
